"use client";
import React, { useEffect, useState } from "react";
import TwoFAQrCode from "../components/QrCodeTwoFA";
import { useAuth } from "../context/AuthContext";
import Toaster from "../components/ui/toaster";
import { enable2FA, verify2FA } from "../services/digitalWalletService";
import { useToast } from "../hooks/use-toast";
import AuthenticateTwoFA from "../components/AuthenticateTwoFA";
import closeIcon from "../assets/images/close.svg";
import { Card } from "../components/ui/card";
import { SecuredFooter } from "../components/ui/secured-footer";
import Authentication from "../assets/images/Authentication.png";
import SendingIcon from "../assets/images/sendingIcon.png";
import { Button } from "./ui/button";

export default function TwoFA({
  closeOverlay,
  isSetUp,
  className,
  on2FAEnabled,
  onDoneClick,
}) {
  const { settings, refreshUser, updateSettings } = useAuth();
  const { toast } = useToast();
  const [authenticate, setAuthenticate] = useState(false);
  const [mainSecret, setMainSecret] = useState(null);
  const [isTwoFAOpen, setIsTwoFAOpen] = useState(false);
  const [sendingPopup, setSendingPopup] = useState(false);
  const [result, setResult] = useState([]);
  const [isVerifying, setIsVerifying] = useState(false);
  const [isEnabled, setIsEnabled] = useState(false);

  useEffect(() => {
    setIsEnabled(settings?.security?.twoFactorAuth?.enabled);
  }, [settings]);
  useEffect(() => {
    if (isEnabled === true) {
      setAuthenticate(true);
    }
  }, [result, isEnabled]);

  useEffect(() => {}, [isEnabled]);

  const handleNext = (secret) => {
    setMainSecret(secret);
    setAuthenticate(true);
  };

  const handleVerify = async (token) => {
    try {
      setIsVerifying(true);
      const otpauthUrl = `otpauth://totp/80Eight?secret=${mainSecret}`;

      const resultData = isEnabled
        ? await verify2FA({ token })
        : await enable2FA({ token, secret: mainSecret, otpauthUrl });

      await setResult(resultData);
      if (!isEnabled) {
        if (resultData?.data?.data) {
          updateSettings(resultData.data.data);
        }
        refreshUser();
        on2FAEnabled?.();
        setSendingPopup(true);
        setIsVerifying(false);
        return;
      }

      if (resultData?.data?.data) {
        updateSettings(resultData.data.data);
      }
      await refreshUser();
      if (resultData) {
        toast({
          description: `2FA ${isEnabled ? "verified" : "enabled"} Successfully`,
          variant: "eighty",
        });
        closeOverlay();
        isSetUp();
      }
    } catch (error) {
      toast({
        description: `${error}`,
        variant: "eighty",
      });
    } finally {
      setIsVerifying(false);
    }
  };
  const close = () => {
    closeOverlay();
  };

  return (
    <Card className={`w-full shadow-lg bg-white rounded-2xl ${className}`}>
      <Toaster />
      {isTwoFAOpen ? (
        sendingPopup ? (
          <>
            <div className="mb-10 lg:mb-20 mt-10 lg:mt-20 pt-[40px] lg:pt-[60px] pb-[20px] rounded-lg flex flex-col gap-5 items-center justify-center mx-auto w-full lg:w-[378px] px-4 lg:px-1">
              <div className="flex flex-col items-center justify-center mb-6 lg:mb-8">
                <img
                  src={SendingIcon}
                  className="mb-6 lg:mb-10 w-32 lg:w-auto"
                  alt="Sending Icon"
                  width={194}
                  height={136}
                />
                <h3 className="text-2xl lg:text-[32px] font-semibold text-center text-[#57249C] mb-2">
                  2FA Enabled
                </h3>
                <p className="text-[#423E51] text-base lg:text-[20px] mb-6 lg:mb-8 text-center">
                  Your crypto is moving safely, just like you planned.
                </p>
                <Button
                  onClick={async () => {
                    await refreshUser();
                    if (onDoneClick) {
                      onDoneClick();
                    } else {
                      closeOverlay();
                      isSetUp();
                    }
                  }}
                  variant="outline"
                  className="bg-[linear-gradient(86.72deg,#57249C_-10.66%,#EB3366_113.47%)] text-white px-6 py-4 rounded-full font-semibold hover:opacity-90 transition-opacity w-full lg:w-[302px] h-12 lg:h-[64px] text-sm lg:text-[14px]"
                >
                  Done
                </Button>
              </div>
            </div>
          </>
        ) : (
          <>
            {isEnabled === false && authenticate === false && (
              <TwoFAQrCode
                onNext={handleNext}
                onCancel={close}
                existingSecret={mainSecret}
              />
            )}
            {authenticate === true && (
              <AuthenticateTwoFA
                onVerify={handleVerify}
                onCancel={() => setAuthenticate(false)}
                isVerifying={isVerifying}
              />
            )}
          </>
        )
      ) : (
        <div className=" p-6 lg:p-8 mb-10 lg:mb-20 mt-10 lg:mt-20 rounded-lg flex flex-col gap-5 items-center justify-center mx-auto w-full lg:w-[60%]">
          <button
            onClick={close}
            aria-label="Close"
            className="w-8 h-8 rounded-full flex items-center justify-center border border-gray-200 hover:bg-gray-50 ml-auto"
          >
            <img src={closeIcon} alt="Close" className="w-4 h-4" />
          </button>
          <img
            src={Authentication}
            alt="Authentication"
            width={160}
            height={112}
            className="lg:w-[194px] lg:h-[136px]"
          />
          <p className="text-xl lg:text-[24px] text-[#57249C] font-semibold text-center">
            Enable 2-Factor Authentication to transact
          </p>
          <p className="text-center text-[#6D6584] text-sm lg:text-[16px] lg:max-w-none max-w-md">
            80eight requires 2-Factor Authentication in order to keep your
            account secure. By using an authenticator app, you ensure no one
            else can log in and transact using your account.
          </p>
          <Button
            className="bg-[linear-gradient(86.72deg,#57249C_-10.66%,#EB3366_113.47%)] text-white px-6 py-4 rounded-full font-semibold hover:opacity-90 transition-opacity w-full h-12 lg:h-[48px] text-sm lg:text-base"
            onClick={() => setIsTwoFAOpen(true)}
          >
            Enable 2-Factor Authentication
          </Button>
        </div>
      )}

      <SecuredFooter />
    </Card>
  );
}
